module.exports = __webpack_public_path__ + "static/media/1487754_203830279820746_745753373_o.bf1cd655.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/makeup_hair/1487754_203830279820746_745753373_o.jpg
// module id = 343
// module chunks = 0